import React from 'react';
import PropTypes from 'prop-types';

import Macro from './macro';
import LocalizationConsumer from '../../../../l10n/localization-context';

const getMacro = (macro, checkedMacros, onMacrosChange) =>
{
  const { sample, macro: value } = macro;

  const checked = checkedMacros.includes(value);

  return <Macro key={value} sample={sample} value={value} onMacrosChange={onMacrosChange} checked={checked} />;
};

const MacrosSection = ({ section, checkedMacros, onMacrosChange }) =>
{
  const { title, macros } = section;

  return (
    <React.Fragment>
      <tr className="-wa-edit-controls__macros-table-heading">
        <th className="-wa-edit-controls__macros-table-heading-th" colSpan="2">{title}</th>
        <td className="-wa-edit-controls__macros-table-heading-td">
          <LocalizationConsumer id="insert-macros-dialog.header-sample-data" />
        </td>
      </tr>
      {macros.map(macro => getMacro(macro, checkedMacros, onMacrosChange))}
    </React.Fragment>
  );
};

MacrosSection.propTypes = {
  section: PropTypes.shape({
    title: PropTypes.string.isRequired,
    macros: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      macro: PropTypes.string.isRequired,
      sample: PropTypes.string.isRequired
    })).isRequired
  }).isRequired,
  checkedMacros: PropTypes.arrayOf(PropTypes.string).isRequired,
  onMacrosChange: PropTypes.func.isRequired
};

export default MacrosSection;

